// Custom react-modal styles
const modalStyles = {
  content: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    marginRight: '0',
    transform: '0',
    padding: 0,
    borderRadius: 0,
    border: 0,
  },
  overlay: {
    zIndex: 1000,
  },
}

export default modalStyles
